import { Navigate } from "react-router-dom";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import {
  RosterDashboardSectionProvider,
  SectionRosterSectionPicker,
  useRosterDashboardSectionId,
  useRosterDashboardSectionSelection,
  useSectionRosterActivity
} from "@/features/roster-activity";
import { HOME_DASHBOARD_OVERVIEW_PATH } from "../constants";
import RosterMovementsPanel from "./_components/RosterMovementsPanel";

function SectionRosterDashboardContent() {
  const sectionId = useRosterDashboardSectionId();
  const { bands, loading, error, refetch } = useSectionRosterActivity(sectionId);

  if (!sectionId) {
    return null;
  }

  return (
    <div data-testid="section-roster-dashboard-page">
      <RosterMovementsPanel
        sectionId={sectionId}
        bands={bands}
        loading={loading}
        error={Boolean(error)}
        onRetry={() => refetch()}
      />
    </div>
  );
}

export default function SectionRosterDashboardPage() {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { sections, sectionId, setSectionId, canViewRosterActivity, loading } = useRosterDashboardSectionSelection();

  if (!flagsLoaded || loading) {
    return null;
  }

  if (flags["backoffice-section-roster-activity"] !== true || !canViewRosterActivity || !sectionId) {
    return <Navigate to={HOME_DASHBOARD_OVERVIEW_PATH} replace />;
  }

  return (
    <RosterDashboardSectionProvider sectionId={sectionId}>
      <div className="mt-4 flex flex-col gap-4">
        {sections.length > 1 ? (
          <div className="flex justify-end">
            <SectionRosterSectionPicker sections={sections} sectionId={sectionId} onSectionChange={setSectionId} />
          </div>
        ) : null}
        <SectionRosterDashboardContent />
      </div>
    </RosterDashboardSectionProvider>
  );
}
